// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
import { HolidayService } from '../../holiday/services/HolidayService';
import { User } from '../../common/modules/user/models/User';
import { SessionStorageService } from '../../common/modules/core/services';
import { SessionService } from '../../common/modules/user/services/SessionService';
import { UserService } from '../../common/modules/user/services/UserService'
@Component({
    selector: 'other-parent-navigate',
    template: require('./OtherParentNavigateComponent.html'),
    styles: [require('./OtherParentNavigateComponent.sass')],
})

export class OtherParentNavigateComponent implements OnInit{
    private services: any = [];
    private hostName: string;
    userData: User;
    message:        string;
    messageType:    string;
    private parent: any
    constructor(
		private router: Router,
		private userService: UserService,
		private sessionService: SessionService,
        private holidayService: HolidayService,
    ) {
    }
    ngOnInit() {
        this.hostName = window.location.hostname
        this.userData = this.userService.getUserSessionData();
        if(!this.userData) {
            this.router.navigate(['/'])
        }
    }
    
    toHoliday() {
        this.convertParent();
        switch(this.hostName){
            case "services.aisvietnam.com":
               setTimeout(function() { window.location.href = 'https://holidayschool.aisvietnam.com'; }, 500) 
                break;
            case "services.eca.dev.nascorp.vn":
               setTimeout(function() { window.location.href = 'http://holiday.eca.dev.nascorp.vn/'; }, 500) 
                break;
            case "services.eca.test.nascorp.vn":
               setTimeout(function() { window.location.href = 'http://holiday.eca.test.nascorp.vn/'; }, 500) 
                break;
            case "services.eca.uat.nascorp.vn": 
               setTimeout(function() { window.location.href = 'http://holidayschool.eca.uat.nascorp.vn'; }, 500)
                break;
            case "services.local.eca.dev.nascorp.vn":
               setTimeout(function() { window.location.href = 'http://holiday.local.eca.dev.nascorp.vn'; }, 500)
                break;
        };
    }

    private convertParent() {
        this.holidayService.convertParent()
            .subscribe(
                complete    => {
                    this.getSession();
                },
                error   => {
                }
            );
    }
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.userService.userDataChanged(user);
                    this.userData = this.userService.getUserSessionData();
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    private getParent() {
        this.holidayService.getParent()
            .subscribe(
                parent => {
                    this.parent = parent;

                    if(this.parent.status === "fill-info") {
                        this.router.navigate(['/profile/add-parent'])
                    }
                    else if(this.parent.status == "full") {
                        this.router.navigate(['/booking/students'])
                    }
                    else {
                        this.router.navigate(['/add-student'])
                       
                    }
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/services/other-parent-navigate/OtherParentNavigateComponent.ts